console.log("B2B hooks")
window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}

const handleChangeVariantQuickView = ({shopData, customAttr}) => {
    setTimeout(() => {
        const selectOptions = document.querySelectorAll(".product-variants .purchase-section .select .single-option-selector");
        if (selectOptions) {
            selectOptions.forEach(select => {
                select.addEventListener("change", () => {
                    const priceElement = document.querySelector("#product-id-product-template-quick > div.product-details.text-center.six > h2.offers.test1 > span.money");
                    if (priceElement) {
                        priceElement.removeAttribute("bss-b2b-product-active");
                    }
                    setTimeout(() => {
                        let variantIdsArr = BSS_B2B.getQueryArray();
                        let variantId = variantIdsArr.variant;
                        BSS_B2B.cp.changeProductPrice(shopData, customAttr, false, true, variantId);
                    }, 500)
                })
            })
        }
    }, 1000)
}
window.BSS_B2B.addAction(`change_variant`, handleChangeVariantQuickView);